var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("checkboxComponent", {
    attrs: { disabled: _vm.disabled, checked: _vm.checked }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }